
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'test',
	'visualizationSlideoutTitle': 'Visualisaties',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Voer een getal in',
	'maxValuePlaceholder': 'Voer een getal in',
	'customRangeErrorMessage': 'Waarde moet een getal zijn',
	'propFillColor': 'Opvulkleur',
	'propBorderColor': 'Kaderkleur',
	'propColorPalette': 'Huidige kleurenpalet',
	'propColorPaletteChangeLabel': 'Kleurenpalet wijzigen',
	'propNewColorPaletteLabel': 'Aangepast kleurenpalet maken',
	'propNewHeatPaletteLabel': 'Aangepast heatpalet maken',
	'propDonutRadius': 'Ringstraal',
	'showTitleLabel': 'Titel afbeelden',
	'titleTypeLabel': 'Type titel',
	'smartTitleLabel': 'Slimme titel',
	'customTitleLabel': 'Aangepaste titel',
	'noTitleLabel': 'Geen titel',
	'propHeatScalePalette': 'Huidige heatpalet',
	'propHeatPaletteChangeLabel': 'Heatpalet wijzigen',
	'propMaintainAxisScales': 'Asschaal handhaven',
	'propLineAndSymbolColor': 'Kleur van lijnen en symbolen',
	'propLineAndSymbolPalette': 'Kleurenpalet lijn en symbool',
	'propElementColor': 'Kleuren van elementen',
	'propColumnColor': 'Kolomkleur',
	'propColumnPalette': 'Kleurenpalet voor kolom',
	'propColumnHeatPalette': 'Heatpalet kolom',
	'propBarColor': 'Staafkleur',
	'propGoalColor': 'Doelkleur',
	'propToColor': 'Tot-kleur',
	'propFromColor': 'Vanaf-kleur',
	'propNumberValidationErrorMessageId': 'Voer een getal in',
	'fontSizeAuto': 'Automatisch',
	'propAutoBinCount': 'Aantal groepen',
	'propAutoBinToggle': 'Automatische groepering',
	'tabName_general': 'Algemeen',
	'tabName_visDetails': 'Details',
	'tabName_animation': 'Animatie',
	'tabName_mediaDetails': 'Mediagegevens',
	'tabName_webDetails': 'Gegevens webpagina',
	'tabName_imageDetails': 'Afbeeldingsgegevens',
	'tabName_visualization': 'Visualisatie',
	'tabName_text': 'Tekst',
	'sectionName_colorsAndThemes': 'Kleur en thema\'s',
	'sectionName_appearance': 'Presentatie',
	'sectionName_general': 'Algemeen',
	'sectionName_colorPalette': 'Kleur',
	'sectionName_axis': 'As',
	'sectionName_axis_label': 'As',
	'sectionName_legend': 'Legenda',
	'sectionName_chart': 'Diagram',
	'sectionName_regionLayer': 'Regioniveau',
	'sectionName_pointLayer': 'Puntniveau',
	'sectionName_latLongLayer': 'Breedtegraad/lengtegraad-laag',
	'sectionName_pathLayer': 'Padlaag',
	'sectionName_xAxis': 'X-as',
	'sectionName_yAxis': 'Y-as',
	'sectionName_xAxis_title': 'Titel X-as',
	'sectionName_yAxis_title': 'Titel Y-as',
	'sectionName_xAxis_label': 'Label x-as',
	'sectionName_yAxis_label': 'Label Y-as',
	'sectionName_column_yAxis': 'Kolom Y-as',
	'sectionName_column_yAxis_label': 'Label van kolom Y-as',
	'sectionName_column_yAxis_title': 'Titel van kolom Y-as',
	'sectionName_line_yAxis': 'Lijn Y-as',
	'sectionName_line_yAxis_label': 'Label lijn Y-as',
	'sectionName_line_yAxis_title': 'Titel lijn Y-as',
	'sectionName_title': 'Titel',
	'sectionName_dataValueLabels': 'Gegevenswaardelabels',
	'sectionName_style': 'Stijl',
	'propTransparencyDescription': 'Het object transparanter of minder transparant maken. Typ een waarde tussen 0 en 100',
	'smart_annotation_unauthorized': 'Annotaties: ongeautoriseerde toegang',
	'smart_annotation_method': 'Annotaties: methode niet toegestaan',
	'smart_annotation_media': 'Annotaties: mediatype niet toegestaan',
	'smart_annotation_input': 'Annotaties: invoer ongeldig',
	'smart_annotation_internal': 'Annotaties: interne systeemfout',
	'smart_annotation_generic_error': 'Annotaties: servicefout',
	'smart_annotation_dialog_title': 'Inzichten',
	'smart_annotation_Show_Insights': 'Inzichten afbeelden',
	'smart_annotation_Relationship': 'De relatie is',
	'forecast_enter_number': 'Voer een getal in tussen ',
	'and': ' en ',
	'smart_errors': 'Annotatiefouten:',
	'smart_warnings': 'Annotatiewaarschuwingen:',
	'smart_annotation_insight_icon_title': 'Inzichten',
	'smart_annotations_toggle_on': 'Inzichten aanzetten',
	'smart_annotations_toggle_off': 'Inzichten uitzetten',
	'smart_annotation_toggle_on': 'Inschakelen',
	'smart_annotation_toggle_off': 'Uitschakelen',
	'smart_annotation_insight_unavailable': 'Inzichten zijn momenteel niet beschikbaar',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Inzichten zijn niet beschikbaar als een filter voor de hoogste of laagste procentwaarde wordt toegepast',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Prognose is niet beschikbaar als een filter voor de hoogste of laagste procentwaarde wordt toegepast',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Inzichten zijn niet beschikbaar als er een filter voor hoogste of laagste waarden wordt toegepast en er meer dan één kolom in het veld aanwezig is',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Prognose is niet beschikbaar als er een filter voor hoogste of laagste waarden wordt toegepast en er meer dan één kolom in het veld aanwezig is',
	'forecast_title': 'Prognose',
	'forecast_show': 'Prognose afbeelden',
	'forecast_toggle_on': 'Prognoses inschakelen',
	'forecast_toggle_off': 'Prognoses uitschakelen',
	'statDetailsPerspectiveTitle': 'Analyse',
	'emptyStatDetailsPanel': 'Er is geen aanvullende analyse beschikbaar voor de huidige visualisatie.',
	'predict_errors': 'Analysefouten',
	'predict_warnings': 'Analysewaarschuwingen',
	'fpd_invalid_data_source': 'Deze gegevensbron heeft geen bijbehorende Smarts-module',
	'fpd_network_issue': 'Er was een probleem bij het uitvoeren van een analyse op deze gegevensbron',
	'fpd_data_source_category': 'Smarts-module ontbreekt',
	'fpd_response_errors': 'Fouten voor aanbevolen drivers',
	'fpd_response_warnings': 'Waarschuwingen voor aanbevolen drivers',
	'catalyst_service_bad_request': 'Ongeldig verzoek',
	'catalyst_service_unkown_Id': 'Onbekend opdracht-ID gevonden',
	'catalyst_service_internal_server_error': 'Interne serverfout',
	'catalyst_service_generic_error': 'Fout in Catalyst-service',
	'catalyst_service_error': 'Deze service is momenteel niet beschikbaar',
	'propLegendPosition': 'Positie van legenda',
	'propLeft': 'Links',
	'propRight': 'Rechts',
	'propTop': 'Bovenaan',
	'propBottom': 'Onderaan',
	'propNone': 'Geen',
	'propLegendDisplay': 'Legenda afbeelden',
	'targetThicknessPlaceHolder': '%{min} tot %{max}',
	'targetThicknessErrorMsg': 'Voer een geheel getal in tussen %{min} en %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Drivers (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'geselecteerd)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Standaardwaarden herstellen',
	'possibelKeyDriver_AddNewDrivers': 'Meer drivers toevoegen',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Zoek drivers om toe te voegen',
	'possibleKeyDrivers_MaxPossibleReached': 'Deselecteer enkele drivers om andere toe te voegen of te selecteren',
	'possibleKeyDrivers_Recommended': 'Aanbevolen',
	'visRecommendedTypes': 'Aanbevolen visualisatietypen',
	'visRecommender_smartsfailure': 'aanbevelingen voor visualisatie zijn momenteel niet beschikbaar',
	'visMore': 'Meer...',
	'visMoreTooltip': 'Meer visualisaties',
	'visOtherTypes': 'Andere visualisatietypen',
	'visChange': 'Visualisatie wijzigen',
	'automaticTypeCaption': 'Automatisch',
	'propVisType': 'Visualisatietypen',
	'dlg_loading': 'Bezig met laden...',
	'snippetListChartCaption': 'Lijst van snippets',
	'convoClusterChartCaption': 'Conversatiecluster',
	'areaChartCaption': 'Oppervlak',
	'barChartCaption': 'Staaf',
	'columnChartCaption': 'Kolom',
	'stackedbarChartCaption': 'Gestapelde staven',
	'stackedcolumnChartCaption': 'Gestapelde kolom',
	'bubbleChartCaption': 'Bellen',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Driver-analyse',
	'scatterChartCaption': 'Strooidiagram',
	'lineChartCaption': 'Lijn',
	'pointChartCaption': 'Punt',
	'heatChartCaption': 'Heatmap',
	'bulletChartCaption': 'Bullet',
	'waterfallChartCaption': 'Waterval',
	'radarChartCaption': 'Radar',
	'boxplotChartCaption': 'Doosdiagram',
	'pieChartCaption': 'Cirkeldiagram',
	'mapChartCaption': 'Kaart',
	'radialBarChartCaption': 'Radiaal ',
	'compositeChartCaption': 'Lijn en kolom',
	'wordCloudChartCaption': 'Woordenwolk',
	'networkChartCaption': 'Netwerk',
	'relationshipNetworkChartCaption': 'Relatienetwerk',
	'treemapChartCaption': 'Treemap',
	'packedBubbleChartCaption': 'Gecomprimeerde bellen',
	'hierarcicalPackedBubbleChartCaption': 'Hiërarchische bellen',
	'spiralChartCaption': 'Spiraal',
	'decisionTreeChartCaption': 'Beslisboom',
	'legacyMapChartCaption': 'Legacykaart',
	'sunburstChartCaption': 'Zonnestraal',
	'visUsageComparison': 'Vergelijking',
	'visUsageRelationships': 'Relaties',
	'visUsageTrend': 'Trend',
	'visUsagePartsToWhole': 'Delen t.o.v. geheel',
	'visUsageGeospatial': 'Georuimtelijk',
	'visUsageAdvanced': 'Advanced Analytics',
	'visUsageTablesAndSummary': 'Tabellen en overzicht',
	'visUsageSocialInsights': 'Sociale inzichten',
	'visUsageOther': 'Overige',
	'autoBinActionText': 'Automatisch groeperen',
	'filterAutobinActionText': 'Bins filteren',
	'memberCalculationActionText': 'Lidberekening',
	'toolbarActionCalculation': 'Berekening maken',
	'toolbarActionEditCalculation': 'Berekening bewerken',
	'topBottomRankLabel': 'Rang (%{label})',
	'toolbarDeleteFilterActionText': 'Filter verwijderen',
	'toolbarActionTopKeyDrivers': 'Drivers afbeelden',
	'toolbarActionCustomGroup': 'Aangepaste groep',
	'canNotCreateCustomGroup': 'Deze aangepaste groep kan niet worden gemaakt.',
	'aria_label_datatable': 'Gegevenstabel',
	'summaryCaption': 'Samenvatting',
	'MeasuresCaption': 'Meetwaarden',
	'MeasuresGroupCaption': 'Meetwaardengroep (%{count})',
	'ValuesCaption': 'Waarden',
	'turnInsightsOn': 'Insights aan',
	'turnInsightsOff': 'Insights uit',
	'decisionRules': 'Regels',
	'decisionTree': 'Boomdiagram',
	'decisionSunburst': 'Boom-zonnestraal',
	'switchToDecisionRules': 'Overschakelen naar beslissingsregels',
	'switchToDecisionTree': 'Overschakelen naar beslissingsstructuur',
	'data_group_less_then': 'minder dan %{rangeTo}',
	'data_group_to': '%{rangeFrom} tot < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} en hoger',
	'nullValueContent': '(geen waarde)',
	'sum': 'Som',
	'count': 'Aantal',
	'countdistinct': 'Afzonderlijk tellen',
	'avg': 'Gemiddeld',
	'min': 'Minimum',
	'max': 'Maximum',
	'automatic': 'Aangepast',
	'variance': 'Variantie',
	'stddev': 'Standaardafwijking',
	'median': 'Zwaartelijn',
	'calculated': 'Berekend',
	'none': 'Geen',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Promptwaarden',
	'inputLabelPrompt': 'Waarde',
	'inputPlaceholderPrompt': 'Geef waarde op',
	'inputInvalidText': 'Ongeldige invoer voor type %{dataType}',
	'unSupportedPrompt': 'Niet-ondersteunde prompt',
	'missingDataSource': 'De juiste gegevensbron is niet gevonden.',
	'unSupportedPromptType': 'Het promptscenario wordt niet ondersteund.',
	'preAggregateLabel': 'Promptwaarden uit de gegevensbron toepassen',
	'postAggregateLabel': 'Promptwaarden toepassen in het rapport',
	'preAggregateText': 'Het bereik maakt gebruik van de waarden in de gegevensbron, niet van de waarden die in het dashboard afgebeeld worden.',
	'defaultAggregation_count': 'Aantal',
	'defaultAggregation_countdistinct': 'Afzonderlijk tellen',
	'defaultAggregation_max': 'Maximum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Gemiddeld',
	'defaultAggregation_sum': 'Som',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',
	'keydriver_average': 'Algeheel gemiddelde',
	'keydriver_up_down': 'Geaccentueerde groepen met hoge of lage gemiddelden hebben meer invloed op het doel. Groepen met ongebruikelijk hoog of laag gemiddelde hebben de sterkste invloed.',
	'keydriver_different': 'De geaccentueerde groepen hebben een distributie die significant afwijkt van de algehele distributie. Deze groepen hebben meer invloed op het doel.',
	'topOperator': 'Bovenaan',
	'bottomOperator': 'Onderaan',
	'topBottomFact': '%{operator} %{value}%{percent} per %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Telling voor hoogste of laagste wissen',
	'deleteTopBottomPercent': 'Hoogste of laagste % wissen',
	'topBottomTitle': 'Alleen dit object',
	'deleteTopBottom': 'Telling voor hoogste of laagste wissen',
	'editTopBottom': 'Telling voor hoogste of laagste bewerken',
	'editTopBottomCount': 'Telling voor hoogste of laagste bewerken',
	'editTopBottomPercent': 'Hoogste of laagste % bewerken',
	'ariaDeleteTopBottomCountLabel': 'Druk op DELETE om de telling voor hoogste of laagste te wissen.',
	'ariaDeleteTopBottomPercentLabel': 'Druk op DELETE om de hoogste of laagste % te wissen.',
	'ariaEditTopBottomCountLabel': 'Druk op ENTER om de telling voor hoogste of laagste te bewerken.',
	'ariaEditTopBottomPercentLabel': 'Druk op ENTER om de hoogste of laagste % te bewerken.',
	'ariaDeleteDrillStateLabel': 'Druk op ENTER om de telling voor hoogste of laagste te bewerken.',
	'drillUpStateTitle': 'Omhoog drillen',
	'drillDownStateTitle': 'Inzoomen',
	'ariaEditTopBottomLabel': 'Druk op ENTER om de telling voor hoogste of laagste te bewerken.',
	'ariaDeleteTopBottomLabel': 'Druk op DELETE om de telling voor hoogste of laagste te wissen.',
	'allKeyDriversLabel': 'Auto (alle drivers)',
	'filter_drag_and_drop_single_dock': 'Gegevens hiernaartoe verslepen om deze te filteren',
	'filter_drag_and_drop_all_tabs': 'Gegevens hiernaartoe verslepen om alle tabs te filteren',
	'filter_drag_and_drop_current_tab': 'Gegevens hiernaartoe verslepen om deze tab te filteren',
	'filter_empty_consume_mode': 'Er zijn geen filters toegepast.',
	'filterClearAllItems': 'Alle filters leegmaken',
	'filterDeleteAllItems': 'Alle filters wissen',
	'filterDockChevronLeft': 'Scrollen door de gegevens',
	'filterDockChevronRight': 'Scrollen door de gegevens',
	'filterIconLabel_Single': 'Filters',
	'filterIconLabel_Global': 'Alle tabs',
	'filterIconLabel_Tab': 'Deze tab',
	'filterIconTooltip_Single': 'Filters',
	'filterIconTooltip_Global': 'Filters voor alle tabbladen',
	'filterIconTooltip_Tab': 'Filters voor dit tabblad',
	'filterDropZoneTooltip_Single': 'Neerzetgebied filteren',
	'filterDropZoneTooltip_Global': 'Neerzetgebied voor alle tabbladen filteren',
	'filterDropZoneTooltip_Tab': 'Neerzetgebied voor dit tabblad filteren',
	'filterOverflowMenu': 'Meer',
	'expand': 'Uitvouwen',
	'collapse': 'Samenvouwen',
	'filterDockItemNameAriaLabel': 'Druk op Enter om het filtervenster te starten en het filter te definiëren.',
	'filterItemCanvasMove': 'Aan canvas toevoegen',
	'filterItemDelete': 'Filter wissen',
	'filterInvertRange': 'alles behalve: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Niet na %{from}',
	'filter_date_after': 'Na %{from}',
	'filter_date_before_except': 'Niet voor %{to}',
	'filter_date_before': 'Voor %{to}',
	'filter_date_between_except': 'Niet tussen %{from}-%{to}',
	'filter_date_between': 'Tussen %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Alle',
	'filter': 'Filteren',
	'filterExcept': 'behalve %{values}',
	'filterDockToolbarButtonLabel': 'Filterdock',
	'navigateTitle': 'Navigeren naar',
	'navigateSelectColumn': 'Selecteer een kolom',
	'navigateSelectPath': 'Selecteer een navigatiepad',
	'current_nav_group': 'De huidige navigatiegroep is%{navigation_group_name}',
	'next': 'Volgende',
	'previous': 'Vorige',
	'multiselectMsg': '%{count} geselecteerd',
	'errMsgFilterItemMissingTitle': 'De filterwaarde(n) %{itemName} kan/kunnen niet worden geladen omdat deze waarden niet beschikbaar zijn voor deze gegevensset',
	'errMsgFilterItemGenericTitle': 'Filterwaarden kunnen niet geladen worden',
	'textFilterItemsNotFound': 'Er zijn geen items beschikbaar.',
	'nullValueLabel': '(blanco)',
	'filterConditionLabel': 'Filtervoorwaarde',
	'filter_includesAll': 'Inclusief alle',
	'filter_allMembersOfSet': 'Alle leden van de set',
	'modelFilter': 'Filteren',
	'filtersTitle': 'Filtereigenschappen',
	'search': 'Zoeken',
	'clearTextFilterValue': 'Verwijderen',
	'invertFilterSelection': 'Inverteren',
	'modellingLoading': 'Bezig met laden...',
	'searchAll': 'Alle kolommen zoeken',
	'toolbarActionPossibleKeyDrivers': 'Bereik bewerken',
	'toolbarActionPossibleKeyDriversSubTitle': 'Sleep items vanaf links om ze mee te laten wegen in het driveranalysediagram.',
	'toolbarActionSort': 'Sorteren',
	'toolbarActionSortAscending': 'Oplopend',
	'toolbarActionSortDescending': 'Aflopend',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionSortCustom': 'Aangepast',
	'toolbarActionFormat': 'Gegevens indelen',
	'toolbarActionFormatText': 'Gegevens indelen (tekst)',
	'toolbarActionFormatAbbreviation': 'Afkorten',
	'toolbarActionFormatNone': 'Automatisch',
	'toolbarActionFilter': 'Filteren',
	'toolbarActionTopBottom': 'Bovenste of onderste',
	'toolbarActionRmvShape': 'Vorm verwijderen',
	'toolbarActionToggleShapeDrop': 'Vorm van infographic',
	'toolbarActionToggleShapeDropTitle': 'Een infographic maken',
	'toolbarActionToggleShapeDropText': 'Maak een infographic door een vorm naar dit veld te slepen.',
	'toolbarActionAggregationType': 'Samenvatten',
	'toolbarDeleteActionText': 'Kolom verwijderen',
	'toolbarTextActionText': 'Stijl tekst',
	'toolbarActionFilterLocalKeepSelected': 'Behouden',
	'toolbarActionFilterLocalExcludeSelected': 'Uitsluiten',
	'toolbarActionFilterAllKeepSelected': 'Filteren',
	'toolbarActionSimpleCalculation': 'Eenvoudige berekening',
	'toolbarActionDrillBack': 'Terug',
	'toolbarActionDrillUp': 'Omhoog drillen',
	'toolbarActionDrillDown': 'Inzoomen',
	'toolbarActionJumpTo': 'Doordrillen',
	'toolbarActionNavigate': 'Navigeren',
	'toolbarActionCreateFilterGroup': 'Nieuwe verbinding maken',
	'toolbarActionDisconnectFilterGroup': 'Alle verbindingen verbreken',
	'toolbarActionLinkFilterGroup': 'Toevoegen aan een bestaande verbinding',
	'toolbarActionLassoSelect': 'Tool selecteren',
	'toolbarActionRefreshDeveloperWidget': 'Vernieuwen',
	'textFontFamilySubClassHairline': 'Haarlijn',
	'textFontFamilySubClassThin': 'Dun',
	'textFontFamilySubClassThinItalic': 'Dun cursief',
	'textFontFamilySubClassExtraLight': 'Extra licht',
	'textFontFamilySubClassExtraLightItalic': 'Extra licht cursief',
	'textFontFamilySubClassLight': 'Licht',
	'textFontFamilySubClassLightItalic': 'Licht cursief',
	'textFontFamilySubClassRegular': 'Normaal',
	'textFontFamilySubClassRegularItalic': 'Normaal cursief',
	'textFontFamilySubClassItalic': 'Cursief',
	'textFontFamilySubClassMedium': 'Medium',
	'textFontFamilySubClassMediumItalic': 'Medium cursief',
	'textFontFamilySubClassHeavy': 'Zwaar',
	'textFontFamilySubClassHeavyItalic': 'Zwaar cursief',
	'textFontFamilySubClassDemiBold': 'Half vet',
	'textFontFamilySubClassDemiBoldItalic': 'Half vet cursief',
	'textFontFamilySubClassBold': 'Vet',
	'textFontFamilySubClassBoldItalic': 'Vet cursief',
	'textFontFamilySubClassExtraBold': 'Extra vet',
	'textFontFamilySubClassExtraBoldItalic': 'Extra vet cursief',
	'textFontFamilySubClassBlack': 'Zwart',
	'textFontFamilySubClassBlackItalic': 'Zwart cursief',
	'textFontFamilySubClassStencil': 'Stencil',
	'dlg_ascending': 'oplopend',
	'dlg_descending': 'aflopend',
	'dlg_custom': 'aangepast',
	'dlg_none': 'geen',
	'dlg_hierarchy': 'hiërarchie',
	'dlg_namedSet': 'benoemde set',
	'dlg_rank': 'rank',
	'visualizationLabel': 'Visualisatie',
	'chartLabel': '%{chartName}-diagram',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Druk op F12 om binnen de widget te navigeren.',
	'f10KeyDescription': 'Druk op F10 om de focusweergave van de widget te starten',
	'playButtonLabel': 'Afspelen',
	'dataPlayerValueListLabel': 'Waarden voor gegevensspeler',
	'localFilterTitle': 'Alleen dit object',
	'globalFilterTitle': 'Alle objecten',
	'deleteFilter': 'Filter wissen',
	'editFilter': 'Filter bewerken',
	'ariaEditFilterLabel': 'Druk op ENTER om de filter te bewerken.',
	'ariaDeleteFilterLabel': 'Druk op DELETE om de filter te wissen.',
	'measureFilterBetween': 'Tussen %{lowerBound} en %{upperBound}',
	'measureFilterNotBetween': 'Niet tussen %{lowerBound} en %{upperBound}',
	'dimFilterIn': 'Bevat: %{in}',
	'dimFilterNotIn': 'Bevat niet: %{out}',
	'gtFilter': 'Na %{lowerBound}',
	'ltFilter': 'Voor %{upperBound}',
	'ariaEditPrompt': 'Druk op ENTER om de promptwaarde te wijzigen',
	'dataPointFilterTitle': 'Gegevenspunten',
	'dataPointFilterIncludeSummary': 'Inbegrepen %{valueCount} gegevenspunten',
	'dataPointFilterExcludeSummary': 'Uitgesloten %{valueCount} gegevenspunten',
	'widgetFiltersLabel': 'Widgetfilters',
	'coachMarkTitleSpiralTarget': 'Bereik bewerken',
	'coachMarkContentSpiralTarget': 'Dit is de plek waar u toegang hebt tot de driverselectie voor uw doel en waar u wijzigingen kunt aanbrengen.',
	'srILVTreeLabel': 'Lijst',
	'geomapUnrecognizedLocations': 'Niet-herkende locaties:',
	'geomapAmbiguousLocations': 'Ambigue regio\'s:',
	'visualizationNotifications': 'Meldingen voor visualisaties:',
	'dataNotifications': 'Meldingen voor gegevens:',
	'autobinSuggestion': 'Automatische groepering inschakelen',
	'LIVE_empty_visualization_hint_title': 'Uw visualisatie samenstellen',
	'LIVE_empty_visualization_hint_description': 'Sleep gegevens hierheen of naar de velden.',
	'LIVE_slots_required_field_description': '%{asterisk} Geeft een verplicht veld aan',
	'LIVE_slots_drag_and_drop_description': 'Sleep gegevens naar de bovenstaande velden om de visualisatie te bouwen en te filteren.',
	'dwErrorLoadingAvailableVisualizations': 'We kunnen de beschikbare visualisatiedefinities niet laden',
	'moreDataIndicator': 'Uw gegevens zijn afgekapt bij %{threshold} items. Pas een filter toe om minder af te beelden.',
	'nonCtxTopBottomInvalid': 'Het definiëren van een hoogste of laagste regel zonder context wordt niet ondersteund voor kruistabellen. Dit is uit deze kruistabelview verwijderd. Herdefinieer de regel op een of meer categorieën in de context van %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'We kunnen het object niet laden, omdat er een visualisatiedefinitie in ontbreekt.',
	'dwErrorLoadingVisualizationListNotFound': 'We kunnen de visualisatie niet laden',
	'dwErrorRunningQuery': 'De gegevens kunnen niet worden opgehaald uit gegevensset %{datasetName}.',
	'dwErrorGeoData': 'Er zijn problemen met het afbeelden van geografische gegevens op een kaart. Kies een ander type visualisatie. ',
	'dwPromptSignonCancelWarning': 'De gegevens voor deze visualisatie zijn niet beschikbaar. Geef de juiste legitimatiegegevens op.',
	'dwErrorMissingDataset': 'De visualisatie kan niet worden geladen omdat de bijbehorende gegevensset "%{datasetName}" niet beschikbaar is.',
	'dwErrorRenderingVisualization': 'We kunnen deze visualisatie niet laden',
	'dwErrorVisualizationTooSmall': 'De visualisatie is te klein voor het afbeelden van de daarin aanwezige gegevens. Maak de visualisatie groter of verminder het aantal gegevens.',
	'errorSourceNotFound': 'De visualisatie kan niet worden geladen omdat de bijbehorende bron "%{sourceName}" niet beschikbaar is.',
	'errorActionNotSupported': 'Deze actie wordt niet ondersteund voor gegevensbron "%{sourceName}".',
	'errorMeasureNotSupportedOnMultiEdges': 'De visualisatie heeft meetwaarden op meerdere randen; dit wordt niet meer ondersteund. Plaats meetwaarden op niet meer dan één rand.',
	'errorExceedAllowableValue': 'Het geschatte aantal cellen is meer dan de toegestane waarde 100000. Voer filtering op de geprojecteerde sets uit om het aantal cellen te verminderen.',
	'propScaleLabel': 'Aantal pictogrammen',
	'propScaleDescription': 'Selecteer het aantal pictogrammen',
	'propScaleFew': 'Laagste',
	'propScaleDefault': 'Standaardwaarde',
	'propScaleMany': 'Hoogste',
	'lastRefresh': 'Laatste vernieuwing: %{timeInterval} geleden',
	'widgetTimer': 'Widgettimer',
	'datasetItemsUnavailable': 'Sommige gegevensset-items die in deze visualisatie worden gebruikt, zijn niet beschikbaar.',
	'datasetItemUnavailable': 'Dit item van de gegevensset is niet beschikbaar.',
	'retry': 'Probeer opnieuw',
	'widgetConditionalFormatLabel': 'Besturingsfuncties voor voorwaardelijke indeling in-/uitschakelen',
	'widgetConditionalFormatTitle': 'Kleur voor voorwaardelijke opmaak bewerken',
	'crosstabName': 'Kruistabel',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'Nvt',
	'summaryLabel': '%{label} met waarde %{value}',
	'infographicLabel': '%{label} met waarde %{value}',
	'warning': 'Waarschuwing',
	'swapRowsAndColumns': 'Rijen en kolommen omwisselen.',
	'hideSummariesLabel': 'Samenvattingen verbergen',
	'showSummariesLabel': 'Overzichten afbeelden',
	'hideRowColumn': 'Verbergen',
	'showAllRowColumn': 'Alles afbeelden',
	'dataAssetPropertiesLabel': 'Eigenschappen van visualisatie',
	'evAdd': 'Kolom toevoegen',
	'evCollapse': 'Samenvouwen',
	'evColumns': 'Kolommen',
	'evLocalFilters': 'Lokale filters',
	'evExpand': 'Uitvouwen',
	'evFilterTooltip': 'Filteren',
	'missingColumn': 'Ontbrekend: %{columnLabel}',
	'missingFiltering': 'Ontbrekende filters voor kolommen:',
	'missingDataItem': 'Het gegevensitem "%{dataItemId}" waarnaar wordt verwezen, is niet gevonden in de widget.',
	'heatByLabel': 'Heat op basis van',
	'toolbarChangeVisualization': 'Visualisatie wijzigen',
	'modellingRelatedTablesNoneFound': 'Geen gerelateerde tabellen gevonden',
	'processing': 'Verwerken...',
	'errorCellWarning': 'Sommige samenvattingswaarden kunnen niet worden berekend.',
	'aggregateTypeToggler': 'Aggregatietype afbeelden',
	'maxColumnsExceeded': 'Maximum aantal kolommen is overschreden. %{columns} verwijderd.',
	'unboundColumns': 'De volgende kolommen kunnen niet worden gebruikt: %{columns}.',
	'unboundColumn': 'De volgende kolom kan niet worden gebruikt: %{columns}.',
	'recommendRequestFailed': 'Aanbevelingsverzoek is mislukt. Neem contact op met de beheerder.',
	'visualizationDoesNotSupportOLAP': 'Deze visualisatie, die op een OLAP-bron wordt gebruikt, kan niet worden gemaakt. Gebruik een andere ondersteunde gegevensbron.',
	'showDataBehindVizLabel': 'Gegevens afbeelden',
	'showDataBehindVizNotSupportedLabel': 'Afbeelden van gegevens wordt niet ondersteund voor dit type visualisatie',
	'exploreData': 'Verkennen...',
	'newExplore': 'Nieuwe verkenning',
	'thumbnails_error_fetching': 'Fout bij het ophalen van miniaturen',
	'loadedThumbnailImage': 'Miniatuurafbeelding van visualisatie %{visType} is geladen',
	'autobinAxisLabel': 'groepen',
	'recommended_visualizations': 'Aanbevolen visualisaties',
	'all_visualizations': 'Alle visualisaties',
	'edit': 'Bewerken',
	'selectTargetDialogTitle': 'Selecteer een doordrildoel',
	'noTargetInCM': 'Het doordrildoel is niet gevonden',
	'errorDrillDefinition': 'Er is iets misgegaan tijdens het toevoegen of bewerken van de doordrildefinitie.',
	'errorDrillToTarget': 'Fout bij doordrillen naar "%{targetName}"',
	'drillThroughMappingViewLabel': 'Wijs kolommen uit uw dashboard toe aan de prompts van het doelrapport',
	'drillthroughScopeRadioLabel': 'Pas deze definitie toe op:',
	'drillthroughScopeRadioOptionVisualization': 'Alleen deze visualisatie',
	'drillthroughScopeRadioOptionConnection': 'Visualisaties met dezelfde verbinding die dezelfde gegevensbron gebruiken',
	'drillthroughScopeRadioOptionDashboard': 'Elke visualisatie op %{perspective} die dezelfde gegevensbron gebruikt',
	'drillThroughParametersColumnTitle': 'Prompts voor "%{targetName}":',
	'drillThroughMetadataColumnTitle': 'Gegevenskolommen voor "%{boardName}":',
	'drillThroughDefinitionNoParameter': 'Het doordrildoel heeft geen prompts.',
	'drillThroughDefinitionErrorQueryingReport': 'Los het probleem met het doelrapport op en probeer vervolgens opnieuw om de doordrildefinitie te maken.',
	'drillThroughDefinitionErrorDlgTitle': 'Er is iets misgegaan',
	'dlg_back': 'Teruggaan',
	'dlg_close': 'Sluiting',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Annuleren',
	'dlg_apply': 'Toepassen',
	'dlg_create': 'Maken',
	'dlg_done': 'Gereed',
	'drillthrough_unsaveMsg': 'Doorgaan zonder "%{name}" op te slaan?',
	'drillthrough_jumpTo': 'Definitie voor doordrillen: %{name}',
	'drillthrough_jumpToLabel': 'Doordrillen',
	'drillthrough_manage': 'Beheren...',
	'drillthrough_addNewTarget': 'Een nieuwe doordrildefinitie toevoegen',
	'drillthrough_manageJumpPaths': 'Definities voor doordrilbewerkingen beheren',
	'drillthrough_manageJumpPaths_edit': '"%{name}" bewerken',
	'drillthrough_manageJumpPaths_delete': '"%{name}" wissen',
	'drillthrough_manageAddAnotherTarget': 'Een andere doordrildefinitie toevoegen',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Wissen bevestigen',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Weet u zeker dat u doordrilbewerking "%{name}" wilt wissen?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Naam van doordrilbewerking dupliceren',
	'drillthrough_definitionMessage': 'Doordrilbewerking "%{name}" bestaat al. Geef een andere naam op.',
	'drillthrough_jumpToTarget_notFound': 'Doel niet gevonden voor doordrilbewerking "%{name}"',
	'drillThroughDefinitionNoParameterSubTitle': 'Er wordt geen context doorgegeven aan het doelrapport.',
	'drillthrough_titleLabel': 'Naam',
	'drillthrough_create_dialogTitle': 'Definitie voor doordrillen maken',
	'drillthrough_edit_dialogTitle': 'Definitie voor doordrillen bewerken',
	'drillthrough_subTitle': 'De context van de visualisatie in uw bron wordt gebruikt om het doel %{perspective} te filteren.',
	'drillthrough_selectColumn': 'Selecteer een kolom',
	'noPrompt': 'Geen prompts',
	'promptDialog': '%{promptType}-promptdialoogvenster',
	'formatAutoDescription': 'Met Automatisch wordt de uit de gegevensbron ov visualisatie overgenomen indeling gebruikt',
	'formatDefaultDescription': 'Met Standaard wordt de uit het systeem overgenomen indeling gebruikt',
	'createCustomGroupAction': 'Gegevensgroep maken',
	'removeCustomGroupAction': 'Gegevensgroep verwijderen',
	'editCustomGroupAction': 'Gegevensgroep bewerken',
	'renameCustomGroupAction': 'Naam van gegevensgroep wijzigen',
	'createCustomGroupErrorToast': 'Uw gegevensgroep kan niet worden gemaakt.',
	'removeCustomGroupErrorToast': 'Uw gegevensgroep kan niet worden verwijderd.',
	'editCustomGroupErrorToast': 'Uw gegevensgroep kan niet worden bewerkt.',
	'renameCustomGroupErrorToast': 'De naam van uw gegevensgroep kan niet worden gewijzigd.',
	'customGroupLabel': 'Gegevensgroep maken',
	'ungroupCustomGroupLabel': 'Groepering opheffen',
	'renameCustomGroupLabel': 'Naam wijzigen',
	'createCustomGroupLabel': 'Maken',
	'customGroupingLabel': '%{columnLabel} (Groep)',
	'createCustomSort': 'Aangepaste sorteerbewerking maken',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Selecteer beschikbare items en sorteer ze. Op die manier maakt u een aangepaste sorteerbewerking.',
	'availableItems': 'Beschikbare items',
	'selectAll': 'Alles selecteren',
	'customSortOrder': 'Aangepaste sorteervolgorde',
	'selectAvailableItemsDesc': 'Selecteer beschikbare items en rangschik ze hier opnieuw.',
	'moveToTop': 'Bovenaan plaatsen',
	'clear': 'Verwijderen',
	'sortRemainingItemsBy': 'Overige items sorteren op',
	'removeAll': 'Alles verwijderen',
	'resetTooltip': 'Alle items worden verwijderd uit de lijst %{customSortOrder}. En de vervolgkeuzelijst %{sortRemainingItemsBy} wordt teruggezet naar de standaardversie.',
	'manyItemsWarning': 'Als u een groot aantal items selecteert, kan dat negatieve gevolgen hebben voor de performance van uw dashboard.',
	'manyItemsSelected': 'Er zijn meer dan %{maxItems} items geselecteerd; dit kan negatieve gevolgen hebben voor de prestaties van uw dashboard.',
	'somethingWentWrong': 'Helaas. Er is iets misgegaan.',
	'tryAgain': 'Opnieuw proberen',
	'customSortLabel': 'Aangepast sorteren',
	'applyError': '%{action} kan niet worden toegepast.',
	'searchReturnedNoResults': 'Uw zoekopdracht heeft geen resultaat opgeleverd.',
	'extVisSystem': 'Systeem',
	'extVisCustom': 'Aangepast',
	'customVisTestVisualization': 'Visualisatie testen',
	'extVisCustomVisPreview': 'preview',
	'extVisCustomPreviewWidgets': 'Widgets voor ontwikkelaars',
	'extVisCustomVVisualization': 'Visualisatie',
	'extVisCustomVisuals': 'Aangepaste visuele weergave',
	'noPermissionToManage': 'U bent niet gemachtigd om aangepaste visualisaties te beheren.',
	'extVisCustomUpdate': 'Bijwerken',
	'extVisCustomDelete': 'Verwijderen',
	'extVisNoCustomVisuals': 'Geen aangepaste visuele weergaven',
	'extVisNoCustomVisualsMsg': 'Er zijn momenteel geen aangepaste visuele weergaven in uw organisatie',
	'extVisAddCustomVisual': 'Een aangepaste visualisatie toevoegen',
	'extVisNoCustomVisualsAdminMsg': 'Er zijn momenteel geen aangepaste visuele weergaven. Voeg er een toe om te beginnen',
	'extVisNoSDKConnection': 'Er is geen verbinding gemaakt met uw lokale bestand',
	'extVisNoSDKPreviewMsg': 'Om een preview van uw visualisaties te bekijken, moet u een verbinding tot stand brengen.',
	'extVisMore': 'Meer',
	'extVisDeleteDialogTitle': 'Aangepaste visuele weergaven wissen',
	'extVisDeleteDialogBody': 'Weet u zeker dat u deze aangepaste visualisatie wilt wissen? Mogelijk wordt deze gebruikt door andere dashboards en rapporten.',
	'extVisDeleteConfirmation': 'Uw aangepaste visuele weergave is gewist.',
	'extVisDeleteError': 'Uw aangepaste visuele weergave kan niet worden gewist. %{msg}',
	'extVisCloseToast': 'Nu sluiten',
	'extVisAdd': 'Uw aangepaste visuele weergave is toegevoegd.',
	'extVisAddError': 'Uw aangepaste visuele weergave kan niet worden toegevoegd. %{msg}',
	'extVisUpdate': 'Uw aangepaste visuele weergave is bijgewerkt.',
	'extVisUpdateError': 'Uw aangepaste visuele weergave kan niet bijgewerkt worden. %{msg}',
	'extVisAddProgress': '%{name} importeren',
	'extVisUpdateProgress': '%{name} bijwerken',
	'extPermissionTitle': 'Beperkte toegang of gewiste aangepaste visuele weergave',
	'extPermissionBody': 'Deze aangepaste visuele weergave kan niet worden bekeken omdat hij gewist of beperkt toegankelijk is.',
	'customVizSaveWarning': 'Uw aangepaste visuele weergaven kunnen niet worden opgeslagen. Ze zijn nog niet geïmporteerd.',
	'schematicTestCaption': 'Schematisch diagram testen',
	'schematicServiceRequestError': 'Fout in service voor schematisch diagram',
	'extVisPreviewMessage': 'Dit is een preview. De visualisatie is nog niet aan het product toegevoegd.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Niet-gedefinieerd',
	'kpiDefaultTargetLabel': 'Doel',
	'kpiNonNumericTarget': 'De doelwaarde moet een getal zijn.',
	'kpiManualTargetSlotFilled': 'Waarde toegepast in veld',
	'kpiAutoValueSize': 'Automatisch',
	'kpiUnableDrawSparklineLabel': 'Minidiagram kan niet getekend worden',
	'kpiUnableDrawSparklineInfo': 'Voor een minidiagram zijn minimaal twee punten in de tijd vereist. Wijzig de gegevens of pas de filters aan om het minidiagram te zien.',
	'conditionalFormattingTextColor': 'Tekstkleur',
	'suppression': 'Onderdrukking',
	'suppressNone': 'Geen',
	'suppressRowsAndColumns': 'Rijen en kolommen',
	'suppressRows': 'Rijen',
	'suppressColumns': 'Kolommen',
	'enableSuppression': 'Onderdrukking inschakelen',
	'disableSuppression': 'Onderdrukking uitschakelen',
	'loadVisDefinitionError': 'Definitie kan niet worden geladen voor visualisatie %{id}',
	'emptyVisualization': 'Lege visualisatie',
	'expandCollapse': 'Uitvouwen en samenvouwen',
	'expandBtnLabel': 'Uitvouwen',
	'collapseBtnLabel': 'Samenvouwen',
	'prop_sizeInputNonNumericValue': 'De waarde moet een getal zijn.',
	'prop_sizeValueShouldBeHigher': 'De waarde moet groter zijn dan %{value}.',
	'fontPropLabel': 'Letterfamilie',
	'fontSizePropLabel': 'Lettergrootte',
	'sectionItemAxisTitle': 'Titel item-as',
	'sectionItemAxisLabel': 'Label item-as',
	'sectionValueAxisTitle': 'Titel waarde-as',
	'sectionValueAxisLabel': 'Label waarde-as',
	'styletext-widget.legend': 'Legenda',
	'styletext-itemAxis.ticks.labels': 'Aslabels',
	'styletext-valueAxis.title': 'Astitels',
	'styletext-itemAxis.title': 'Astitels',
	'styletext-labels': 'Gegevenslabels',
	'styletext-valueAxis.line.title': 'Lijntitels',
	'styletext-cellValue': 'Waarden',
	'styletext-values': 'Waarden',
	'styletext-rowHeading': 'Rijkopteksten',
	'styletext-columnHeading': 'Kolomkopteksten',
	'fontFamily': 'familie',
	'fontSize': 'grootte',
	'visExportFileName': 'Visualisatie',
	'ds-missingDataSet': 'Gegevensset is niet gevonden. Zorg ervoor dat de gegevensset is gemaakt.',
	'ds-missingDashboardId': 'Sla het dashboard op voordat u de gegevensset maakt.',
	'ds-unsupportedDataSourceType': 'Het type %{type} wordt niet ondersteund voor de gegevensbron.',
	'dataCache': 'Gegevenscache',
	'dataCache_on': 'Aan',
	'dataCache_off': 'Geen cache',
	'dataCache_auto': 'Automatisch',
	'queryOptimization': 'Queryoptimalisatie'
});
